// Slogan.js

import React, { useEffect, useRef, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import '../styles/components/Slogan.scss';

const Slogan = () => {
    const sloganRef = useRef(null);
    const fxRef = useRef(null);
    const bgRef = useRef(null);
    const playedLettersRef = useRef(new Set());
    const hasInteractedRef = useRef(false);

    const [canPlaySound, setCanPlaySound] = useState(false);
    const [showSlogan, setShowSlogan] = useState(false);
    const [showPrompt, setShowPrompt] = useState(true); // 👈 affiche l'invite

    const { t } = useLanguage();

    const title = "MOVIEFRENZY";

    useEffect(() => {
        const unlockSound = () => {
            if (hasInteractedRef.current) return;
            hasInteractedRef.current = true;

            fxRef.current = new Audio('/camera-flash.mp3');
            bgRef.current = new Audio('/boom-geomorphism-cinematic-trailer-sound-effects.mp3');

            fxRef.current.volume = 0.075;
            bgRef.current.volume = 0.25;
            bgRef.current.loop = false;

            setCanPlaySound(true);
            // Nouveau comportement avec classe "disparition"
            setShowPrompt("fading"); // active l'effet de fondu

            setTimeout(() => {
                setShowPrompt(false); // ensuite, on la retire du DOM
            }, 500); // durée du fade-out en ms


            setTimeout(() => {
                bgRef.current?.play()
                    .catch(err => console.warn("Lecture du son bloquée :", err))
                    .finally(() => setShowSlogan(true));
            }, 2000);

            window.removeEventListener('click', unlockSound);
            window.removeEventListener('touchstart', unlockSound);
        };

        const handleVisibilityChange = () => {
            if (document.hidden) {
                fxRef.current?.pause();
                bgRef.current?.pause();
            }
        };

        window.addEventListener('click', unlockSound);
        window.addEventListener('touchstart', unlockSound);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('click', unlockSound);
            window.removeEventListener('touchstart', unlockSound);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const playSound = (e, index) => {
        if (!canPlaySound || playedLettersRef.current.has(index)) return;
        playedLettersRef.current.add(index);

        fxRef.current.currentTime = 0;
        fxRef.current.play().catch(err => console.warn("Erreur FX :", err.message));

        const el = e?.target;
        if (el) {
            el.classList.add('flash-effect');
            setTimeout(() => el.classList.remove('flash-effect'), 200);
        }
    };

    return (
        <div className="slogan-container">
            <p className="slogan-text">{t('slogan.main')}</p>
            <div aria-live="polite" className="visually-hidden">
                Animation du titre MOVIEFRENZY, avec effets sonores et visuels au clic utilisateur.
            </div>
            {showPrompt && (
                <div className={`click-icon ${showPrompt === "fading" ? "fade-out" : ""}`} aria-label="Cliquez pour démarrer">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="#FF33CC" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 1L15 8H9L12 1ZM12 23L9 16H15L12 23ZM1 12L8 15V9L1 12ZM23 12L16 9V15L23 12ZM4.22 4.22L8.34 8.34L4.22 4.22ZM19.78 19.78L15.66 15.66L19.78 19.78ZM4.22 19.78L8.34 15.66L4.22 19.78ZM19.78 4.22L15.66 8.34L19.78 4.22Z" />
                    </svg>
                    <p>{t('slogan.clickToStart')}</p>
                </div>
            )}

            <div className={`slogan-Logo ${showSlogan ? 'show' : ''}`} ref={sloganRef}>
                <h2 id="h2slogan-Logo">
                    {title.split("").map((letter, index) => (
                        <span
                            key={index}
                            className="slogan-letter"
                            style={{ '--index': index }}
                            onAnimationStart={(e) => playSound(e, index)}
                        >
                            {letter}
                        </span>
                    ))}
                </h2>
            </div>
        </div>
    );
};

export default Slogan;







